import { render, staticRenderFns } from "./TifInspeccionesIndex.vue?vue&type=template&id=5a321fab"
import script from "./TifInspeccionesIndex.vue?vue&type=script&lang=js"
export * from "./TifInspeccionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports